import React, { useState, useEffect, useReducer, useRef } from 'react';
import { SFuncModal } from 'shj-components'
import { Form, Button, Select, Divider, Row, Col, message, Input, Radio } from 'antd';
import { custAccountPrint } from '@/services/fmsServices';
const TextArea = Input.TextArea;
// @ts-ignore
export function printFn({ fn, ...rest }) {
  const onClose = () => {
    dialog.destroy();
  };

  const dialog = SFuncModal({
    title: `${rest?.id ? '打印预览' : '打印预览'}`,
    width: 900,
    vanish: true,
    content: <ModalAddOrEditDom onClose={onClose} fn={fn} {...rest} />,
  });

  return dialog;
}
// @ts-ignore
const ModalAddOrEditDom = ({ onClose, fn, ...rest }) => {
  const [form] = Form.useForm();
  const printiframe = useRef<any>();
  const [addOrEditFooterLoading, setAddOrEditFooterLoading] = useState(false);

  useEffect(() => {
  }, []);

  const replaceAllTemplate = (html: any, item: any) => {
    for (let key in rest.replaceModel) {
      if (item[key] || item[key] === '') {
        html = html.replace(new RegExp(rest.replaceModel[key], 'gm'), item[key] || '');
      }
      // if (key == 'receiverName' || key == 'contractNo' || key == 'paymentAccount') {
      //   html = html.replace(new RegExp(rest.replaceModel[key], 'gm'), item[key] || '');
      // }
    }
    return html;
  };
  // 提交
  const onFinish = (values: any) => {
    const { id } = rest;
    // 合并新值的赋值
    const { 
      transactionJournalId, 
      billPrintConfigId, 
      creator, 
      auditor, 
      receiver, 
      receiverName, 
      printNo, 
      printDate, 
      companyName, 
      transactionCode, 
      bankBranchName, 
      isPrintAgain, 
      printState, 
      bizopId, 
      contractNo, 
      paymentAccount 
    } = rest;

    const newValues = {
      ...values,
      transactionJournalId,
      billPrintConfigId,
      creator,
      auditor,
      receiver,
      receiverName,
      printNo,
      printDate,
      companyName,
      transactionCode,
      bankBranchName,
      isPrintAgain,
      printState,
      bizopId,
      contractNo,
      paymentAccount,
    };
    setAddOrEditFooterLoading(true);
    custAccountPrint({ ...newValues, ...(id && { id }) })
      .then((resp: any) => {
        setAddOrEditFooterLoading(false);
        rest.note = form.getFieldsValue().note;
        let templateHtml = replaceAllTemplate(rest.templateContent, rest);
        // 在新窗口中打开打印页面
        const printWindow = window.open('', '_blank');
        if (printWindow) {
          printWindow.document.write(templateHtml);
          printWindow.document.close(); // 关闭文档以完成写入
          printWindow.print(); // 调用打印
          printWindow.close(); // 打印后关闭窗口
        }
        onClose();
        fn && fn();
      })
      .finally(() => {
        setAddOrEditFooterLoading(false);
      });
  };
  return (
    <div style={{ padding: '15px' }}>
      <div dangerouslySetInnerHTML={{ __html: rest.templateHtml }} style={{ marginBottom: '20px' }}></div>
      <Form form={form} onFinish={onFinish}>
        <Form.Item label="备注" name="note" style={{ marginLeft: '10px', width: '700px' }}>
          <TextArea placeholder="备注" rows={2} />
        </Form.Item>
        <Form.Item>
          <Row>
            <Col span={24}>
              <Divider />
            </Col>
            <Col span={24} style={{ textAlign: 'right' }}>
              <Button type="primary" htmlType="submit" style={{ margin: '0 8px' }} loading={addOrEditFooterLoading}>
                提交
              </Button>
            </Col>
          </Row>
        </Form.Item>
      </Form>
      <iframe style={{ display: 'none' }} ref={printiframe} src="/static/print.html"></iframe>
    </div>
  );
};
